import { inject, injectable } from 'inversify';
import { ModelRuleMapper } from '@Mapper/ninthAge/model-rule.mapper';
import { TYPES } from '@Types';
import { RequestAction, RequestFailure } from '../RequestAction';
import { Locale } from '../locale';
import { ApiClient } from '@Api';
import { Nullable } from '@Models';
import { RequestModelRulesSuccess } from '@Repository/ninthAge/response';

@injectable()
export class ModelRuleRepository {
  @inject(TYPES.Mapper.ModelRuleMapper)
  private _modelRuleMapper!: ModelRuleMapper;
  @inject(TYPES.Api.ApiClient) private _apiClient!: ApiClient;
  @inject(TYPES.Locale) protected _locale!: Locale;

  public async seach({
    versionId,
    armyIds,
    locale,
  }: {
    locale: Nullable<string>;
    versionId: number;
    armyIds: Array<number>;
  }): Promise<RequestAction> {
    try {
      const specialRulesDto = await this._apiClient.ninthAge.searchModelRules({
        locale: locale ?? this._locale.getlocale(),
        versionId: versionId,
        requestBody: { army_ids: armyIds },
      });
      return new RequestModelRulesSuccess({
        payload: specialRulesDto.map((item) => this._modelRuleMapper.map(item)),
      });
    } catch (error: any) {
      console.log('error', error);
      return new RequestFailure({ error: error });
    }
  }
}
